import { Action } from 'redux'
import { CalendarFiltersActions } from '../../../reducers/bookingCalendar/actionNames'

export const filterByDate = (
  data: Pick<
    IFilterCalendarByDate,
    Exclude<keyof IFilterCalendarByDate, 'type'>
  >,
): IFilterCalendarByDate => ({
  ...data,
  type: CalendarFiltersActions.FilterByDate,
})

export interface IFilterCalendarByDate
  extends Action<CalendarFiltersActions.FilterByDate> {
  from?: Date
  to?: Date
  days?: number
}
